import FetchStatusReducerCreator from './'

export default FetchStatusReducerCreator({
  containerNesting: ['byCustomerId'],
})
